import { Link, usePage } from "@inertiajs/react"
import { Card, CardContent } from "@/components/ui/card"
import { BookOpen, ChevronRight, Compass, Heart, MessageCircle, Scale, Target } from "lucide-react"

// Maps the nav `icon` strings (set in App::Member::BaseController#default_tabs)
// to lucide components — same set the sidebar uses.
const FEATURE_ICONS = {
  "book-open": BookOpen,
  heart: Heart,
  "message-circle": MessageCircle,
  scale: Scale,
  target: Target,
  compass: Compass,
}

// Member dashboard "home" for a group whose access level is `none` (R7). With
// no assessment surfaces, instead of a dead-end we welcome the member and link
// the non-assessment features they DO have. Tiles are derived from the shared
// `visibleTabs` nav set, so a tile never points at something the level hides.
export function HiddenAssessmentsState() {
  const { props } = usePage()
  const tabs = props.visibleTabs || []
  const groupName = props.currentGroup?.name
  const features = tabs.filter((tab) => tab.name !== "Home")

  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="py-8 text-center">
          <Compass className="h-10 w-10 mx-auto mb-3 text-kf-red" aria-hidden />
          <h2 className="font-display text-xl text-zinc-900">
            Welcome{groupName ? ` to ${groupName}` : ""}
          </h2>
          <p className="text-sm text-zinc-600 max-w-md mx-auto mt-2">
            Your planning tools will open here when your coach is ready. In the
            meantime, here&apos;s everything your group has for you.
          </p>
        </CardContent>
      </Card>

      {features.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {features.map((feature) => {
            const Icon = FEATURE_ICONS[feature.icon] || Compass
            return (
              <Link
                key={feature.name}
                href={feature.href}
                className="group flex items-center gap-4 rounded-lg border border-zinc-200 bg-white p-4 transition hover:border-kf-red hover:shadow-sm"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-kf-red/10 text-kf-red">
                  <Icon className="h-5 w-5" aria-hidden />
                </span>
                <span className="min-w-0 flex-1 font-medium text-zinc-900">
                  {feature.name}
                </span>
                <ChevronRight
                  className="h-4 w-4 shrink-0 text-zinc-400 group-hover:text-kf-red"
                  aria-hidden
                />
              </Link>
            )
          })}
        </div>
      )}
    </div>
  )
}
